<template>
  <div>
    <!-- <p class="c-inner-title">用户管理</p> -->
    <div class="auto">
      <page-title title="用户管理" icon="fa-windows"></page-title>
    </div>
    <div class="table-wrap m-t-15">
      <el-row class="table-toolbar margin-bottom-10">
        <el-col :span="12">
          <el-button @click="addHandle" type="primary" size="small">新增用户</el-button>
          <!-- <span style="visibility:hidden">1</span> -->
        </el-col>
        <el-col :span="12" align="right">
          <el-select v-model="filter.customer_id" placeholder="选择分类" size="small">
            <el-option key="" label="全部" value=""></el-option>
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-input placeholder="搜索名称/用户名" suffix-icon="el-icon-search" style="margin-left: 5px;margin-right: 5px;width: 200px;" clearable v-model.trim="filter.search" size="small"></el-input>
          <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
        </el-col>
      </el-row>
      <div class="table-content">
        <el-table :data="body" v-loading="loading" style="width: 100%" size="small">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="name" width="150" label="名称"></el-table-column>
          <!-- <el-table-column prop="username" width="150" label="用户名"></el-table-column> -->
          <!-- <el-table-column prop="password" width="150" label="密码"></el-table-column> -->
          <el-table-column prop="customer_id" width="150" label="所属客户">
            <template slot-scope="scope">
              {{customerList.length && customerList.find(item => item.id === scope.row.customer_id) && customerList.find(item => item.id === scope.row.customer_id)['cn_name']}}
            </template>
          </el-table-column>
          <el-table-column prop="jd_pin" width="150" label="JD_PIN"></el-table-column>
          <el-table-column label="状态" prop="status_name">
            <!-- <template slot-scope="scope">
              {{scope.row.status == 0 ? '关闭' : '开启'}}
            </template> -->
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                @click="auditHandle(scope.$index)"
                type="primary"
                size="small" class="m-tb-5">
                信息修改
              </el-button>
              <el-button
                @click="showTable(scope.row)"
                type="primary"
                size="small" class="m-tb-5">
                设置权限
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="Number(filter.page)"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(filter.limit)"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- <el-dialog title="用户操作" :visible.sync="addUserModal">
      <el-form :model="form" ref="form" label-width="80px" size="small" :rules="formRule">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="username" label="用户名">
          <el-input v-model.trim="form.username"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input v-model.trim="form.password"></el-input>
        </el-form-item>
        <el-form-item prop="customer_id" label="所属客户">
          <el-select v-model="form.customer_id" placeholder="选择客户">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="form.status" placeholder="选择状态">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="addSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="用户操作" :visible.sync="addUserModal">
      <el-form :model="auditForm" ref="auditFormRef" label-width="80px" size="small" :rules="auditFormRule">
        <el-form-item prop="name" label="姓名">
          <el-input v-model.trim="auditForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="company" label="公司">
          <el-input v-model.trim="auditForm.company"></el-input>
        </el-form-item>
        <el-form-item prop="username" label="用户名">
          <el-input v-model.trim="auditForm.username"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input v-model.trim="auditForm.password"></el-input>
        </el-form-item>
        <el-form-item prop="customer_id" label="所属客户">
          <el-select v-model="auditForm.customer_id" placeholder="选择客户">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="auditForm.status" placeholder="选择状态">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="auditSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增用户" :visible.sync="addUserVisibility">
      <el-form :model="addForm" ref="addFormRef" label-width="90px" size="small" :rules="addFormRule">
        <el-form-item prop="name" label="姓名">
          <el-input v-model.trim="addForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="company" label="公司">
          <el-input v-model.trim="addForm.company"></el-input>
        </el-form-item>
        <el-form-item prop="jd_name" label="JD_NAME">
          <el-input v-model.trim="addForm.jd_name"></el-input>
        </el-form-item>
        <el-form-item prop="jd_pin" label="JD_PIN">
          <el-input v-model.trim="addForm.jd_pin"></el-input>
        </el-form-item>
        <el-form-item prop="username" label="用户名">
          <el-input v-model.trim="addForm.username"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input v-model.trim="addForm.password"></el-input>
        </el-form-item>
        <el-form-item prop="customer_id" label="所属客户">
          <el-select v-model="addForm.customer_id" placeholder="选择客户">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="addForm.status" placeholder="选择状态">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="addUserSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看权限" :visible.sync="moduleDialogVisible">
      <el-table :data="authResult['authorizer']" v-loading="authLoading">
        <el-table-column
          label="公众号"
          prop="nick_name"
          width="120">
        </el-table-column>
        <el-table-column
          prop="module"
          label="权限">
          <template slot-scope="scope">
            <div v-for="(k, i) in moduleIds[scope.row.id].moduleList" :key="i" class="border-bottom margin-bottom-10">
              <el-checkbox :indeterminate="moduleIds[scope.row.id]['module'][k.key]['im']" v-model="moduleIds[scope.row.id]['module'][k.key]['all']" @change="handleCheckAllChange(scope.row.id, k)">{{k.name}}</el-checkbox>
              <el-checkbox-group v-model="moduleIds[scope.row.id]['module'][k.key]['arr']" @change="handleCheckedChange(scope.row.id, k)">
                <el-checkbox v-for="_k in k['module']" :label="_k.key" :key="_k.key">{{_k.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moduleDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="setAuthorizer" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="用户操作记录" :visible.sync="userLogDialogVisible">
      <el-table :data="userLog">
        <el-table-column
          label="页面链接"
          prop="url">
        </el-table-column>
        <el-table-column
          label="操作类型"
          prop="event">
        </el-table-column>
        <el-table-column
          label="时间"
          prop="local_time">
          <template slot-scope="scope">
            {{util.timeStampFormat(scope.row.local_time, 'yyyy-MM-dd h:m:s')}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {System} from '@/model'
export default {
  data () {
    return {
      authLoading: false,
      loading: false,
      addUserVisibility: false,
      addUserModal: false,
      formRule: {
        name: [
          { required: true, message: '名称不能为空！', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '用户名不能为空！', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空！', trigger: 'blur' }
        ],
        customer_id: [
          { required: true, message: '所属客户不能为空！', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空！', trigger: 'blur' }
        ]
      },
      form: {
        username: '',
        name: '',
        password: '',
        status: '1',
        customer_id: ''
      },
      addFormRule: {
        name: [
          { required: true, message: '姓名不能为空！', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '公司不能为空！', trigger: 'blur' }
        ],
        jd_name: [
          { required: true, message: 'JD_NAME不能为空！', trigger: 'blur' }
        ],
        jd_pin: [
          { required: true, message: 'JD_PIN不能为空！', trigger: 'blur' }
        ],
        customer_id: [
          { required: true, message: '所属客户不能为空！', trigger: 'blur' }
        ]
      },
      addForm: {
        company: '',
        name: '',
        jd_name: '',
        jd_pin: '',
        username: '',
        password: '',
        status: '1',
        customer_id: ''
      },
      auditFormRule: {
        name: [
          { required: true, message: '姓名不能为空！', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '公司不能为空！', trigger: 'blur' }
        ],
        customer_id: [
          { required: true, message: '所属客户不能为空！', trigger: 'blur' }
        ]
      },
      auditForm: {
        id: '',
        status: '1',
        name: '',
        username: '',
        password: '',
        customer_id: '',
        company: ''
      },
      body: [],
      options: [
        {id: '0', name: '关闭'},
        {id: '1', name: '开启'}
      ],
      pw: {
        old: '',
        new: '',
        new_re: ''
      },
      pwModal: false,
      formClone: {},
      customerList: [],
      moduleDialogVisible: false,
      search: '',
      customer_id: '',
      authList: [],
      btnLoading: false,
      authResult: {
        user: [],
        authorizer: []
      },
      moduleList: [],
      moduleIds: {},
      userId: '',
      module: [],
      userLog: [],
      userLogDialogVisible: false,
      filter: {
        customer_id: '',
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0,
      updateStatus: false
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        customer_id: '',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/system/system/user', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.index()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    toggleSelection (rows) {
      setTimeout(() => {
        if (rows) {
          rows.forEach(row => {
            this.$refs['multipleTable'].toggleRowSelection(row)
          })
        } else {
          this.$refs['multipleTable'].clearSelection()
        }
      }, 100)
    },
    async setAuthorizer () {
      let objModule = {}
      let flag = false
      for (let key in this.moduleIds) {
        objModule[key] = {}
        objModule[key]['module'] = []
        let mo = this.moduleIds[key]['module']
        for (let k in mo) {
          let obj = {}
          obj['key'] = k
          obj['module'] = []
          if (mo[k].arr.length) {
            flag = true
            obj['module'] = [...mo[k].arr]
            objModule[key]['module'].push(obj)
          }
        }
      }
      if (!flag) {
        this.$message.error('至少需要选择一项！')
        return false
      }
      this.btnLoading = true
      let res = await System.setAuthorizer({
        user_id: this.userId,
        module: objModule
      })
      this.btnLoading = false
      if (res !== false && !res['err_code']) {
        this.$message.success('提交成功!')
        this.index()
        this.moduleDialogVisible = false
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    handleCheckAllChange (id, k) {
      let all = this.moduleIds[id]['module'][k.key]['all']
      let arr = []
      if (all) {
        k['module'].map(res => {
          arr.push(res['key'])
        })
      }
      this.moduleIds[id]['module'][k.key]['arr'] = [...arr]
      this.moduleIds[id]['module'][k.key]['im'] = false
    },
    handleCheckedChange (id, k) {
      let length = this.moduleIds[id]['module'][k.key]['arr'].length
      let wholeLength = k['module'].length
      this.moduleIds[id]['module'][k.key]['im'] = length > 0 && length < wholeLength
      this.moduleIds[id]['module'][k.key]['all'] = length === wholeLength
    },
    showTable (row) {
      this.userAuthorizer(row['id'])
      this.userId = row['id']
      this.moduleDialogVisible = true
    },
    addHandle () {
      this.addUserVisibility = true
    }, 
    handle (index) {
      // this.search = ''
      this.updateStatus = false
      let row = Object.assign({}, this.formClone)
      if (index > -1) {
        this.updateStatus = true
        row = this.body[index]
        row['status'] = String(row['status'])
      }
      this.form = row
      this.addUserModal = true
    },
    addCancel () {
      this.addUserModal = false
      this.addUserVisibility = false
      this.addForm = {
        company: '',
        name: '',
        jd_name: '',
        jd_pin: '',
        status: '1',
        customer_id: ''
      }
    },
    auditHandle (index) {
      // this.search = ''
      this.updateStatus = false
      let row = Object.assign({}, this.formClone)
      if (index > -1) {
        this.updateStatus = true
        row = this.body[index]
        row['status'] = String(row['status'])
      }
      this.auditForm = row
      this.addUserModal = true
    },
    auditCancel () {
      this.addUserModal = false
      this.auditForm = {
        id: '',
        status: '1',
        name: '',
        username: '',
        password: '',
        customer_id: '',
        company: ''
      }
    },
    async addUserSubmit () {
      this.$refs['addFormRef'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          let res = await System.userDoSubmit(this.addForm)
          this.btnLoading = false
          if (res !== false && !res['err_code']) {
            this.$message.success('提交成功!')
            if (!this.updateStatus) {
              this.resetFilter()
            }
            this.index()
            this.addUserVisibility = false
          } else {
            this.$message.error(res['err_msg'])
          }
        } else {
          return false
        }
      })
    },
    async auditSubmit () {
      this.$refs['auditFormRef'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          let res = await System.auditUser(this.auditForm)
          this.btnLoading = false
          if (res !== false && !res['err_code']) {
            this.$message.success('提交成功!')
            if (!this.updateStatus) {
              this.resetFilter()
            }
            this.index()
            this.addUserModal = false
          } else {
            this.$message.error(res['err_msg'])
          }
        } else {
          return false
        }
      })
    },
    async addSubmit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid && this.form.username.trim() && this.form.name.trim() && this.form.password.trim()) {
          this.btnLoading = true
          let res = await System.userDoSubmit(this.form)
          this.btnLoading = false
          if (res !== false && !res['err_code']) {
            this.$message.success('提交成功!')
            if (!this.updateStatus) {
              this.resetFilter()
            }
            this.index()
            this.addUserModal = false
          } else {
            this.$message.error(res['err_msg'])
          }
        } else {
          return false
        }
      })
    },
    async index () {
      let res = await System.userIndex(this.filter)
      if (res !== false && !res['err_code'] !== 0) {
        this.body = res['data']['list']
        this.total = res['data']['total']
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async customer () {
      let res = await System.customer()
      if (res['err_code'] !== 0) {
        this.$message.error(res['err_msg'])
      } else {
        this.customerList = [...res['data']]
        this.index()
      }
    },
    async userAuthorizer (userId) {
      this.authLoading = true
      let res = await System.userAuthorizer({user_id: userId})
      this.authLoading = false
      if (res['err_code'] !== 0) {
        this.$message.error(res['err_msg'])
      } else {
        this.authResult = res['data']
        let moduleIds = {}
        res['data']['authorizer'].map(item => {
          let k = item['id']
          moduleIds[k] = {}
          moduleIds[k]['moduleList'] = [...item['module']]
          let obj = {}
          this.moduleList.map(_item => {
            let k = _item['key']
            obj[k] = {
              'arr': [],
              'all': false,
              'im': false
            }
          })
          moduleIds[k]['module'] = obj
        })
        res['data']['user'].map(item => {
          let m = item['module']
          for (let k in m) {
            let has = this.moduleList.find(_item => _item['key'] === k)
            if (has && has['module']) {
              let wholeLength = has['module'].length
              // console.log('moduleIds', moduleIds)
              // console.log('authorizer_id', item['authorizer_id'])
              if (moduleIds[item['authorizer_id']]) {
                moduleIds[item['authorizer_id']]['module'][k]['arr'] = [...m[k]]
                moduleIds[item['authorizer_id']]['module'][k]['all'] = m[k].length === wholeLength
                moduleIds[item['authorizer_id']]['module'][k]['im'] = m[k].length > 0 && m[k].length < wholeLength
              }
            }
          }
        })
        this.moduleIds = moduleIds
      }
    },
    async getModuleList () {
      let res = await System.getModuleList()
      if (res !== false && !res['err_code'] !== 0) {
        this.moduleList = [...res['data']]
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async getUsetStatusList () {
      let res = await System.getUsetStatusList()
      if (res !== false && !res['err_code'] !== 0) {
        // this.options = [...res['data']]
        let options = []
        res['data'].map((item, index) => {
          options.push({
            id: index,
            name: item
          })
        })
        this.options = options
      } else {
        this.$message.error(res['err_msg'])
      }
    }
  },
  created () {
    this.formClone = Object.assign({}, this.form)
    this.queryToFilter()
    this.customer()
    this.getModuleList()
    this.getUsetStatusList()
  }
}
</script>
<style scoped>

</style>
